import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "fill"];
import React from 'react';

var ForwardArrowIcon = function ForwardArrowIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#333' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: fill,
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.22 3.97a.75.75 0 0 1 1.06 0l7.5 7.5A.754.754 0 0 1 21 12l-.004-.074c.002.015.003.03.003.046L21 12a.763.763 0 0 1-.129.42.748.748 0 0 1-.09.11l.068-.078a.75.75 0 0 1-.005.006l-.064.072-7.5 7.5a.75.75 0 0 1-1.06-1.06l6.219-6.22H3.75a.75.75 0 0 1-.743-.648L3 12a.75.75 0 0 1 .75-.75h14.689l-6.22-6.22a.75.75 0 0 1-.072-.976z"
  }));
};

ForwardArrowIcon.displayName = 'ForwardArrowIcon';
export default ForwardArrowIcon;